import React from 'react';
import { Col, CustomInput, Form, FormGroup, Label, Row } from 'reactstrap';
import BurgerMenu from '../../commons/BurgerMenu';
import { useTranslation } from 'react-i18next';
import Header from '../../commons/Header';
import { ReactComponent as IcnDocument } from '../../images/icn_document.svg';
import {
  BtnRadiusWhite,
  ContFilterYear,
  ContFlexLeft,
  ContPaginationPage,
  H4Styled,
  H5Styled,
} from '../../styled-components';
import { Link, useLocation } from 'react-router-dom';
import { ReactComponent as IconBack } from '../../images/icn-back.svg';
import variables from '../../variables';
import ActivitiesDetailTable from './ActivitiesDetailTable';
import Footer from '../../commons/Footer';
import generatePaginationOptions from '../../lib/helpers/generatePaginationOptions';
import SearchInput from '../../commons/SearchInput';

const ActivitiesDetailsPresentational = ({
  data,
  total,
  offset,
  limit,
  onFilter,
  profile,
  query,
  documentTypes,
  agreementTypes,
  suppliers,
  documents,
  totalDocuments,
  limitDocuments,
  offsetDocuments,
  onFilterDocuments,
  onSelectChange,
  onSelectAll,
  selectedAll,
  selectedDocuments,
  activityId,
  uploadAgreements,
  setSelectedSupplier,
  setSelectedCondo,
  setRequiredDocuments,
  missDocumentsRequired,
  documentsForRequired,
}) => {
  const [t] = useTranslation('ACTIVITIES');

  const location = useLocation();
  const activityName = location.state?.activityName;

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <section>
          <Header
            title={t('PAGES:ACTIVITIES')}
            icon={<IcnDocument fill="#ffffff" style={{ height: '25px' }} />}
          />
        </section>

        <Row style={{ marginBottom: '10px' }}>
          <Col sm="12" md="6">
            <ContFlexLeft>
              <Link to={`/activities`}>
                <BtnRadiusWhite>
                  <IconBack fill={variables.primary} />
                </BtnRadiusWhite>
              </Link>
              <H4Styled>{t('TITLE_DETAIL')}</H4Styled>
            </ContFlexLeft>
          </Col>
        </Row>

        <Row
          xs={8}
          className="align-items-center"
          style={{ justifyContent: 'space-between' }}
        >
          <Col>
            <H5Styled>
              {t('AREA')}: {activityName}
            </H5Styled>
          </Col>
        </Row>

        <Row className="search-add-cont m-t-20" style={{ rowGap: '10px' }}>
          <Col sm="6" md="6" lg="3" xl="3">
            <SearchInput
              query={{ search: query && query.name }}
              onFilter={({ search }) => onFilter({ name: search })}
              label={t('SEARCH:NAME')}
            />
          </Col>
          <Col sm="6" md="6" lg="3" xl="3">
            <SearchInput
              query={{ search: query && query.vatCode }}
              onFilter={({ search }) => onFilter({ vatCode: search })}
              label={t('SEARCH:VAT_CODE')}
            />
          </Col>
          <Col sm="6" md="6" lg="3" xl="3">
            <SearchInput
              query={{ search: query && query.maintainer }}
              onFilter={({ search }) => onFilter({ maintainer: search })}
              label={t('SEARCH:MAINTAINER')}
            />
          </Col>
          <Col sm="12" md="6" lg="3" className="select-wrapper">
            <ContFilterYear className="no-width">
              <Row>
                <Col xs="6">
                  <Label>Stato condomini</Label>
                </Col>
                <Col xs="6">
                  <FormGroup>
                    <CustomInput
                      type="select"
                      id="condosState"
                      name="condosState"
                      onChange={(e) =>
                        onFilter({
                          condosState: e.target.value,
                        })
                      }
                      value={query.condosState || ''}
                    >
                      <option value="" defaultChecked>
                        Tutti
                      </option>
                      <option value="ACTIVE">Con Contratti</option>
                      <option value="NOT_ACTIVE">Senza Contratti</option>
                    </CustomInput>
                  </FormGroup>
                </Col>
              </Row>
            </ContFilterYear>
          </Col>
        </Row>

        <section>
          <ActivitiesDetailTable
            data={data}
            total={total}
            offset={offset}
            limit={limit}
            onFilter={onFilter}
            profile={profile}
            documentTypes={documentTypes}
            agreementTypes={agreementTypes}
            suppliers={suppliers}
            documents={documents}
            totalDocuments={totalDocuments}
            limitDocuments={limitDocuments}
            offsetDocuments={offsetDocuments}
            onFilterDocuments={onFilterDocuments}
            onSelectChange={onSelectChange}
            onSelectAll={onSelectAll}
            selectedAll={selectedAll}
            selectedDocuments={selectedDocuments}
            activityId={activityId}
            uploadAgreements={uploadAgreements}
            setSelectedSupplier={setSelectedSupplier}
            setSelectedCondo={setSelectedCondo}
            setRequiredDocuments={setRequiredDocuments}
            missDocumentsRequired={missDocumentsRequired}
            documentsForRequired={documentsForRequired}
          />

          <ContPaginationPage>
            <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

            <FormGroup>
              <CustomInput
                type="select"
                className="pagination-select"
                id="perPage"
                name="perPage"
                value={query.limit}
                onChange={({ target: { value: limit } }) => {
                  onFilter({ limit });
                }}
              >
                {generatePaginationOptions()}
              </CustomInput>
            </FormGroup>
          </ContPaginationPage>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default ActivitiesDetailsPresentational;
